/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { debounce } from 'lodash';

// Source: https://github.com/lodash/lodash/issues/4815#issuecomment-859379489
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function asyncDebounce(func: any, wait: number) {
  const debounced = debounce(async (resolve, reject, bindSelf, args) => {
    try {
      const result = await func.bind(bindSelf)(...args);
      resolve(result);
    } catch (error) {
      reject(error);
    }
  }, wait);

  // This is the function that will be bound by the caller, so it must contain the `function` keyword.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function returnFunc(this: any, ...args: any[]) {
    return new Promise((resolve, reject) => {
      void debounced(resolve, reject, this, args);
    });
  }

  return returnFunc;
}
